import { imageUrl, srcSet } from '@helpers/image';
import { Device, from } from '@helpers/media';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import { useReducedMotion } from 'framer-motion';
import * as React from 'react';
import S from './SectionDetail.styles';
const SectionDetail = ({ accentColor, active, content, cta, image, tint = 0.3, }) => {
    const reduceMotion = useReducedMotion();
    return (React.createElement(S.Container, { "aria-current": active, initial: active ? 'active' : 'inactive', animate: active ? 'active' : 'inactive', variants: {
            inactive: {
                transition: {
                    when: 'afterChildren',
                },
                transitionEnd: {
                    display: 'none',
                },
            },
            active: {
                display: 'grid',
            },
        }, style: { '--accentColor': accentColor, '--tintAmount': tint } },
        React.createElement(S.ImageWrapper, { variants: {
                inactive: {
                    opacity: 1,
                    zIndex: 0,
                    transitionEnd: {
                        opacity: 0,
                    },
                },
                active: {
                    opacity: 1,
                    zIndex: 1,
                },
            }, transition: {
                duration: 0.3,
                ease: 'easeOut',
            } },
            React.createElement("picture", null,
                React.createElement("source", { media: from(Device.Desktop), srcSet: srcSet(image, { width: 1048, height: 931 }) }),
                React.createElement(S.Image, { alt: image.altText, loading: "lazy", src: imageUrl(image, { width: 875, height: 776 }), srcSet: srcSet(image, { width: 875, height: 776 }) }))),
        React.createElement(S.ContentWrapper, { variants: {
                inactive: {},
                active: {
                    transition: {
                        delayChildren: reduceMotion ? 0 : 0.3,
                        staggerChildren: reduceMotion ? 0 : 0.15,
                    },
                },
            } },
            React.createElement(S.Content, { variants: {
                    initial: {
                        opacity: 0,
                        x: reduceMotion ? 0 : -20,
                    },
                    inactive: {
                        opacity: 0,
                        x: reduceMotion ? 0 : -20,
                    },
                    active: {
                        opacity: 1,
                        x: 0,
                    },
                }, transition: {
                    duration: 0.3,
                    ease: 'easeOut',
                } },
                React.createElement(S.AccentLine, { "aria-hidden": true, "data-position": "top", variants: {
                        initial: {
                            opacity: 0,
                            scaleX: 0,
                        },
                        inactive: {
                            opacity: 0,
                            scaleX: 0,
                        },
                        active: {
                            opacity: 1,
                            scaleX: 1,
                        },
                    }, transition: {
                        duration: 0.3,
                        ease: 'easeOut',
                    } }),
                content,
                React.createElement(S.AccentLine, { "aria-hidden": true, "data-position": "bottom", variants: {
                        initial: {
                            opacity: 0,
                            scaleX: 0,
                        },
                        inactive: {
                            opacity: 0,
                            scaleX: 0,
                        },
                        active: {
                            opacity: 1,
                            scaleX: 1,
                        },
                    }, transition: {
                        duration: 0.3,
                        ease: 'easeOut',
                    } })),
            cta && (React.createElement(S.CtaWrapper, { variants: {
                    initial: {
                        opacity: 0,
                        x: reduceMotion ? 0 : 20,
                    },
                    inactive: {
                        opacity: 0,
                        x: reduceMotion ? 0 : 20,
                    },
                    active: {
                        opacity: 1,
                        x: 0,
                    },
                }, transition: {
                    duration: 0.3,
                    ease: 'easeOut',
                } },
                React.createElement(LinkButton, { buttonType: "inverted", href: cta.url, target: cta.target }, cta.text))))));
};
export default SectionDetail;
